/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Form, Input, DatePicker, Select, Button, InputNumber } from 'antd';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
// import { testDL, testGen } from 'services/boilerplate/boilerplate';

export default function BoilerPlate(props){
    function handleKP(event){
        console.log(event.key);
    }

    async function handleTestGenerate(){    
        // console.log(`shit's working`);
        // window.open('http://localhost:5444/objects/test1');
        // const response = await testGen();
        // console.log(`response => ${response}`);

        const { userID } = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
        const postMonthYear = '202211';
        // console.log(`loggedIn => ${userID}`);
        // console.log('loggedIn/', userID);

        window.open(`${process.env.REACT_APP_BACKEND_API}reports/birSales?userID=${userID}&postMonthYear=${postMonthYear}`);
    }

    async function handleTestDL(){
        // const response = await testDL();
        // console.log(`response => ${response}`);

        window.open(`${process.env.REACT_APP_BACKEND_API}reports/download/1`);
    }

    //test arPerClient
    async function arPerClient(){
        const { userID } = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
        const customer_id = '3';
        // console.log(`loggedIn => ${userID}`);
        // console.log('loggedIn/', userID);

        window.open(`${process.env.REACT_APP_BACKEND_API}reports/arPerClient?userID=${userID}&customerID=${customer_id}`);
    }

    //test colRepPerClient
    async function colRepPerClient(){
        const { userID } = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
        const customer_id = '23';
        // console.log(`loggedIn => ${userID}`);
        // console.log('loggedIn/', userID);

        window.open(`${process.env.REACT_APP_BACKEND_API}reports/colRepPerClient?userID=${userID}&customerID=${customer_id}`);
    }

    //test RPT_SALES_PER_CLNT_MTH
    async function RPT_SALES_PER_CLNT_MTH(){
        const { userID } = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
        const customer_id = '23';
        const inv_year = '2022';
        // console.log(`loggedIn => ${userID}`);
        // console.log('loggedIn/', userID);

        window.open(`${process.env.REACT_APP_BACKEND_API}reports/salesRepPerClientMonth?userID=${userID}&customerID=${customer_id}&postYear=${inv_year}`);
    }

    //test RPT_SALES_PER_MTH_BRKDWN
    async function RPT_SALES_PER_MTH_BRKDWN(){
        const { userID } = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
        const month_year = '202211';
        // console.log(`loggedIn => ${userID}`);
        // console.log('loggedIn/', userID);

        window.open(`${process.env.REACT_APP_BACKEND_API}reports/salesRepPerMonthBr?userID=${userID}&postMonthYear=${month_year}`);
    }

    return(
        <div>
            <Card>
            <Input name='test' placeholder='test' onKeyDown={handleKP}/>
            <br />
            <Input name='test' placeholder='test2' />
            {/* <Button onClick={handleTestGenerate}>test Generate</Button> */}
            <Button onClick={arPerClient}>test Generate</Button>
            <Button onClick={handleTestDL}>test DL</Button>
            </Card>            
        </div>
    );
}